import { HBMMedias } from '../../../../models/configurators-2d/applications/kitchen/hbm-media';

export abstract class HBMConfigurationData {
  configurationId?: string;
  HBMConfigurationId?: string;
  bom?: string;
  projectTitle?: string;
  opportunityNumber?: number;
  medias?: HBMMedias;
  contactedByPhone?: boolean;
}
